import React, { useMemo } from 'react';
import { ThemeProvider, Button, Box, Tooltip, IconButton } from '@mui/material';
import { AddShoppingCart, RemoveShoppingCart, ShoppingCart } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import Select from '../../../../../form/Select';
import SelectEmpresa from '../../../../../form/SelectEmpresa';
import DataList from '../../../../../form/DataList';
import InputNumber from '../../../../../form/InputNumber';

import { formatarNumero } from '../../../../../../utils/masks';

export default function ImovelTabPanel({
    // UI/Tema
    theme,
    // môdulo headless
    module,
    // contexto
    operacao,
    operacaoParametros,
    profile,
    casaDecimal,
    utiliza3digitos,

    // options
    OptionsTabelaPreco,
    OptionsEmpresa,
    OptionsAlmoxarifados,

    // flags
    disabledBtnItem,

    // permissões
    podeEditar,
    podeIncluir,
    podeCancelar,
    podeImprimir,
    podeEditarItem,
    podeCancelarItem,
    podeImprimirItem,
    //message
    setFlashMessage,
}) {
    const { main, draft, list, state, actions, mrt, flags } = module;

    // =========================
    // dados do movimento / item
    // =========================
    const dados = main?.state || {};
    const novoProduto = draft?.value || {};

    // =========================
    // grid
    // =========================
    const data = list?.items || [];
    const rowCount = list?.rowCount || 0;

    // =========================
    // state visual do módulo
    // =========================
    const { Produto = {}, Embalagem = {}, OptionsProdutos = [], OptionsEmbalagem = [] } = state || {};

    // =========================
    // actions do módulo
    // =========================
    const {
        change: onChange = async () => {},
        focus: onFocus = async () => {},
        blur: onBlur = async () => {},
        clear: onLimpar = () => {},
        submitDraft: onSalvarItem = async () => {},
        selectRow: onItemAction = async () => {},
    } = actions || {};

    // =========================
    // flags do módulo
    // =========================
    const { isSaving = false } = flags || {};

    // =========================
    // mrt
    // =========================
    const {
        state: {
            columnFilterFns = {},
            columnFilters = [],
            globalFilter = '',
            pagination = { pageIndex: 0, pageSize: 5 },
            sorting = [],
        } = {},
        setters: {
            setColumnFilterFnsMode = () => {},
            setColumnFilters = () => {},
            setGlobalFilter = () => {},
            setPagination = () => {},
            setSorting = () => {},
        } = {},
        flags: { isLoading: isMrtLoading = false, isRefetching: isMrtRefetching = false, isError: isMrtError = false } = {},
    } = mrt || {};

    const manual = !!dados?.id;

    const columns = useMemo(
        () => [
            {
                id: 'produto',
                header: 'Imóvel selecionado',
                columns: [
                    {
                        accessorKey: 'Produto.descricao',
                        id: 'Produto.descricao',
                        header: 'Descrição',
                        //you can access a cell in many callback column definition options like this
                        muiTableBodyCellProps: ({ cell }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'precoNegociado',
                        header: 'Aluguel',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        accessorFn: (row) =>
                            row.precoNegociado === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.precoNegociado)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'quantidade',
                        header: 'Meses',
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                    },
                    {
                        accessorKey: 'valorTotal',
                        header: 'Valor Total',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        accessorFn: (row) =>
                            row.valorTotal === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.valorTotal)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );

    return (
        <div style={{ margin: '1em' }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <Select
                    name="novoProduto.tabelaPrecoId"
                    text="Tabela de Preço"
                    options={OptionsTabelaPreco}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto.tabelaPrecoId}
                    notOptNull={false}
                />
                <DataList
                    text="Imóvel"
                    name="Produto.descricao"
                    placeholder={'Pesquise o Produto'}
                    inputWidth="400px"
                    filteredOptions={OptionsProdutos}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Produto?.descricao || ''}
                    required={false}
                />
                <InputNumber
                    text={'Aluguel'}
                    type="text"
                    name="novoProduto.precoNegociado"
                    placeholder="Valor R$"
                    inputWidth="100px"
                    title="digite o valor do aluguel"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto.precoNegociado ? formatarNumero(novoProduto.precoNegociado) : ''}
                />
                <InputNumber
                    text={'Meses'}
                    type="text"
                    name="novoProduto.quantidade"
                    placeholder="Período em meses"
                    inputWidth="60px"
                    title="digite a quantidade de meses do contrato"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto.quantidade ? formatarNumero(novoProduto.quantidade) : ''}
                    readonly={true}
                />
                <InputNumber
                    text={'Valor Total'}
                    type="text"
                    name="novoProduto.valorTotal"
                    placeholder="Valor R$"
                    inputWidth="100px"
                    title="digite o valor da venda"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto.valorTotal ? formatarNumero(novoProduto.valorTotal) : ''}
                />

                <Button
                    variant="contained"
                    color="inherit"
                    onClick={onLimpar}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={novoProduto?.funcao?.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                    onClick={onSalvarItem}
                    disabled={disabledBtnItem || isSaving}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    {isSaving ? 'Processando...' : novoProduto?.funcao}
                </Button>
            </div>

            {/* GRID */}
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    columns={columns}
                    data={data || []}
                    rowCount={rowCount || 0}
                    getRowId={(row) => row.uuid ?? row.id}
                    manualPagination={!!manual}
                    manualSorting={!!manual}
                    manualFiltering={!!manual}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    enableRowSelection
                    localization={MRT_Localization_PT_BR}
                    initialState={{ showColumnFilters: true, density: 'compact' }}
                    muiToolbarAlertBannerProps={isMrtError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFilterFnsMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading: isMrtLoading,
                        pagination,
                        showAlertBanner: isMrtError,
                        showProgressBars: isMrtRefetching,
                        sorting,
                    }}
                    renderDetailPanel={({ row }) => (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                gap: '10px',
                                padding: '10px',
                            }}
                        >
                            {row.original.saldoEstoque?.map((empresa, indexEmpresa) => (
                                <Box
                                    key={indexEmpresa}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                        gap: '10px',
                                        backgroundColor: '#353535',
                                        padding: '10px 20px',
                                        borderRadius: '5px',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        color: '#fff',
                                    }}
                                >
                                    <Box sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                                        {empresa.nomeFantasia ?? `Empresa ID: ${empresa.empresaId}`}
                                    </Box>

                                    {empresa.almoxarifados?.map((almox, indexAlmox) => (
                                        <Box
                                            key={indexAlmox}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                backgroundColor: '#505050',
                                                padding: '10px',
                                                borderRadius: '4px',
                                            }}
                                        >
                                            <Box sx={{ fontWeight: 'bold' }}>
                                                Almoxarifado: {almox.descricao ?? `ID ${almox.almoxarifadoId}`}
                                            </Box>

                                            {almox.saldos?.map((saldo, indexSaldo) => (
                                                <Box
                                                    key={indexSaldo}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        backgroundColor: '#606060',
                                                        padding: '6px 12px',
                                                        borderRadius: '4px',
                                                        fontSize: '14px',
                                                    }}
                                                >
                                                    <span>Situação: {saldo.descricaoSituacao ?? `ID ${saldo.situacaoId}`}</span>
                                                    <span>
                                                        Entradas: {saldo.entradas} | Saídas: {saldo.saidas} |{' '}
                                                        <strong>Saldo: {saldo.disponivel}</strong>
                                                    </span>
                                                </Box>
                                            ))}

                                            <Box
                                                sx={{
                                                    marginTop: '8px',
                                                    padding: '6px 12px',
                                                    borderTop: '1px solid #888',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    color: '#fff',
                                                }}
                                            >
                                                Total disponível no almoxarifado:{' '}
                                                <strong style={{ marginLeft: '6px' }}>
                                                    {almox.saldos?.reduce((acc, s) => acc + (s.disponivel ?? 0), 0)}
                                                </strong>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                        </Box>
                    )}
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="top" title={`${row.original.pedido ? 'Editar' : 'Adicionar'}`}>
                                <span>
                                    <IconButton
                                        onClick={() =>
                                            onItemAction?.(row.original, row.index, row.original.pedido ? 'Editar' : 'Adicionar')
                                        }
                                        disabled={row.original.pedido ? !podeEditar : !podeIncluir}
                                    >
                                        {row.original.pedido ? <ShoppingCart /> : <AddShoppingCart />}
                                    </IconButton>
                                </span>
                            </Tooltip>

                            <Tooltip arrow placement="right" title="Cancelar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => onItemAction?.(row.original, row.index, 'Cancelar')}
                                        disabled={!row.original.pedido || !podeCancelar}
                                    >
                                        <RemoveShoppingCart />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                />
            </ThemeProvider>
        </div>
    );
}
